module.exports = __webpack_public_path__ + "img/46.2a98e81.jpg";